import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
    GetCurrencyExchangeSettings,
    GetHomeCategorySelectorSettings,
    UpdateCurrencyExchangeSettings,
    UpdateHomeCategorySelectorSettings,
} from "@/api/services/system-settings";
import { IUpdateCurrencyExchangePayload, IUpdateHomeCategorySelectorPayload } from "@/api/types/system-settings";

export function useGetCurrencyExchangeSettings() {
    return useQuery({
        queryKey: ["currency-exchange-settings"],
        queryFn: () => GetCurrencyExchangeSettings(),
    });
}

export function useUpdateCurrencyExchangeSettings() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (body: IUpdateCurrencyExchangePayload) => UpdateCurrencyExchangeSettings(body),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["currency-exchange-settings"] });
        },
    });
}

export function useGetHomeCategorySelectorSettings() {
    return useQuery({
        queryKey: ["home-category-selector-settings"],
        queryFn: () => GetHomeCategorySelectorSettings(),
    });
}

export function useUpdateHomeCategorySelectorSettings() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (body: IUpdateHomeCategorySelectorPayload) => UpdateHomeCategorySelectorSettings(body),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["home-category-selector-settings"] });
        },
    });
}
